<template>
    <section
        :style="commonConfigStyles"
        class="o-item-details-otg"
    >
        <div class="item-details-otg-logo-container">
            <img
                :src="icon"
                class="item-details-otg-logo"
            >
        </div>
        <div class="item-details-otg-details">
            <span class="item-details-otg-name">
                {{ name }}
            </span>
            <span class="item-details-otg-details-item">
                {{ floor }}
            </span>
            <span
                v-if="distance"
                class="item-details-otg-details-item"
            >
                {{ `Avstand: ${distance} m` }}
            </span>
        </div>
    </section>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'OItemDetailsOtg',
    props: {
        itemId: {
            type: Number,
            require: true
        }
    },
    computed: {
        ...mapGetters([
            't',
            'getObject',
            'getMapConfigProp'
        ]),
        item() {
            return this.getObject(this.itemId) || null;
        },
        icon() {
            return this.t(this.item, 'icon') || '';
        },
        name() {
            return this.t(this.item, 'name') || '';
        },
        floor() {
            return this.t(this.item, 'floor') || '';
        },
        distance() {
            return this.t(this.item, 'distance') || 0;
        },
        commonConfigStyles() {
            return this.getMapConfigProp('components.OItemDetailsOtg.styles') || null;
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />